import React, { useState } from 'react';
import { AVAILABLE_FILTERS, DEFAULT_PAGE_CONFIGS, PageFilterConfig } from '../../types/filters';
import { CheckIcon, GripVerticalIcon } from 'lucide-react';
export function FilterConfiguration() {
  const [pageConfigs, setPageConfigs] = useState<PageFilterConfig[]>(DEFAULT_PAGE_CONFIGS);
  const [selectedPage, setSelectedPage] = useState<string>('campaigns');
  const currentConfig = pageConfigs.find(p => p.pageId === selectedPage);
  const toggleFilter = (filterId: string) => {
    setPageConfigs(prev => prev.map(config => {
      if (config.pageId === selectedPage) {
        const enabled = config.enabledFilters.includes(filterId);
        return {
          ...config,
          enabledFilters: enabled ? config.enabledFilters.filter(id => id !== filterId) : [...config.enabledFilters, filterId]
        };
      }
      return config;
    }));
  };
  const enableAllFilters = () => {
    setPageConfigs(prev => prev.map(config => {
      if (config.pageId === selectedPage) {
        return {
          ...config,
          enabledFilters: AVAILABLE_FILTERS.map(f => f.id)
        };
      }
      return config;
    }));
  };
  const disableAllFilters = () => {
    setPageConfigs(prev => prev.map(config => {
      if (config.pageId === selectedPage) {
        return {
          ...config,
          enabledFilters: []
        };
      }
      return config;
    }));
  };
  const leadFilters = AVAILABLE_FILTERS.filter(f => f.category === 'lead');
  const callFilters = AVAILABLE_FILTERS.filter(f => f.category === 'call');
  const otherFilters = AVAILABLE_FILTERS.filter(f => f.category === 'other');
  return <div data-id="element-2208">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2209">
        Filter Configuration
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2210">
        Configure which filters are available on each page
      </p>

      <div className="grid grid-cols-4 gap-6" data-id="element-2211">
        {/* Page Selection Sidebar */}
        <div className="col-span-1" data-id="element-2212">
          <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-2213">
            <h3 className="font-medium text-gray-800 mb-4 text-sm" data-id="element-2214">Pages</h3>
            <div className="space-y-1" data-id="element-2215">
              {pageConfigs.map(page => <button key={page.pageId} onClick={() => setSelectedPage(page.pageId)} className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${selectedPage === page.pageId ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2216">
                  {page.pageName}
                  <span className="text-xs text-gray-500 block mt-0.5" data-id="element-2217">
                    {page.enabledFilters.length} filters
                  </span>
                </button>)}
            </div>
          </div>
        </div>

        {/* Filter Configuration */}
        <div className="col-span-3 space-y-6" data-id="element-2218">
          <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2219">
            <div className="flex items-center justify-between mb-6" data-id="element-2220">
              <div data-id="element-2221">
                <h2 className="text-lg font-semibold text-gray-800" data-id="element-2222">
                  {currentConfig?.pageName}
                </h2>
                <p className="text-sm text-gray-600" data-id="element-2223">
                  Select which filters to show on this page
                </p>
              </div>
              <div className="flex space-x-2" data-id="element-2224">
                <button onClick={enableAllFilters} className="px-4 py-2 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-2225">
                  Enable All
                </button>
                <button onClick={disableAllFilters} className="px-4 py-2 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-2226">
                  Disable All
                </button>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-6" data-id="element-2227">
              {/* LEAD Filters */}
              <div data-id="element-2228">
                <h3 className="text-sm font-semibold text-blue-600 mb-3 uppercase tracking-wider" data-id="element-2229">
                  Lead
                </h3>
                <div className="space-y-2" data-id="element-2230">
                  {leadFilters.map(filter => {
                  const isEnabled = currentConfig?.enabledFilters.includes(filter.id);
                  return <button key={filter.id} onClick={() => toggleFilter(filter.id)} className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-all ${isEnabled ? 'bg-blue-50 border-2 border-blue-500 text-blue-700' : 'bg-gray-50 border-2 border-transparent text-gray-700 hover:border-gray-300'}`} data-id="element-2231">
                        <span className="flex items-center" data-id="element-2232">
                          <GripVerticalIcon size={14} className="mr-2 text-gray-400" data-id="element-2233" />
                          {filter.label}
                        </span>
                        {isEnabled && <CheckIcon size={16} className="text-blue-600 flex-shrink-0" data-id="element-2234" />}
                      </button>;
                })}
                </div>
              </div>

              {/* CALL Filters */}
              <div data-id="element-2235">
                <h3 className="text-sm font-semibold text-blue-600 mb-3 uppercase tracking-wider" data-id="element-2236">
                  Call
                </h3>
                <div className="space-y-2" data-id="element-2237">
                  {callFilters.map(filter => {
                  const isEnabled = currentConfig?.enabledFilters.includes(filter.id);
                  return <button key={filter.id} onClick={() => toggleFilter(filter.id)} className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-all ${isEnabled ? 'bg-blue-50 border-2 border-blue-500 text-blue-700' : 'bg-gray-50 border-2 border-transparent text-gray-700 hover:border-gray-300'}`} data-id="element-2238">
                        <span className="flex items-center" data-id="element-2239">
                          <GripVerticalIcon size={14} className="mr-2 text-gray-400" data-id="element-2240" />
                          {filter.label}
                        </span>
                        {isEnabled && <CheckIcon size={16} className="text-blue-600 flex-shrink-0" data-id="element-2241" />}
                      </button>;
                })}
                </div>
              </div>

              {/* OTHER Filters */}
              <div data-id="element-2242">
                <h3 className="text-sm font-semibold text-blue-600 mb-3 uppercase tracking-wider" data-id="element-2243">
                  Other
                </h3>
                <div className="space-y-2" data-id="element-2244">
                  {otherFilters.map(filter => {
                  const isEnabled = currentConfig?.enabledFilters.includes(filter.id);
                  return <button key={filter.id} onClick={() => toggleFilter(filter.id)} className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-all ${isEnabled ? 'bg-blue-50 border-2 border-blue-500 text-blue-700' : 'bg-gray-50 border-2 border-transparent text-gray-700 hover:border-gray-300'}`} data-id="element-2245">
                        <span className="flex items-center" data-id="element-2246">
                          <GripVerticalIcon size={14} className="mr-2 text-gray-400" data-id="element-2247" />
                          {filter.label}
                        </span>
                        {isEnabled && <CheckIcon size={16} className="text-blue-600 flex-shrink-0" data-id="element-2248" />}
                      </button>;
                })}
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-2249">
            <h4 className="font-medium text-blue-900 mb-2 text-sm" data-id="element-2250">
              How it works
            </h4>
            <ul className="text-sm text-blue-800 space-y-1" data-id="element-2251">
              <li data-id="element-2252">
                • Enabled filters will appear in the header filter bar on the
                selected page
              </li>
              <li data-id="element-2253">• By default, all filters are enabled for all pages</li>
              <li data-id="element-2254">
                • Users can apply filters from the header, and selections
                persist across navigation
              </li>
              <li data-id="element-2255">
                • Click on a filter to enable/disable it for the current page
              </li>
            </ul>
          </div>

          <div className="flex justify-end" data-id="element-2256">
            <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-2257">
              Save Configuration
            </button>
          </div>
        </div>
      </div>
    </div>;
}